module.exports = __webpack_public_path__ + "img/25.8bce4f81.svg";